<template>
    <ReferralInformationForm />
    <PreadmissionNotes />
</template>

<script src="./ReferralInformation.ts"></script>
